import { DocumentVersion } from '../../../api/model/document';

export const parseVersion = (version: string) => {
  const [major, minor] = version.split('.').map(Number);
  return { major, minor } as unknown as DocumentVersion;
};
